import { render, staticRenderFns } from "./ImportDropzone.vue?vue&type=template&id=eb21e13a&scoped=true"
import script from "./ImportDropzone.vue?vue&type=script&lang=js"
export * from "./ImportDropzone.vue?vue&type=script&lang=js"
import style0 from "./ImportDropzone.vue?vue&type=style&index=0&id=eb21e13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb21e13a",
  null
  
)

export default component.exports